import React from "react";

const ChevronCompactDown = () => {
    return (
        <svg width="3em" height="3em" viewBox="0 0 16 16" className="bi bi-chevron-compact-down"
             fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd"
                  d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"/>
        </svg>
    );
};

export default ChevronCompactDown;